import {styled} from '@mui/system'

export const InsuranceUserSummaryStyled = styled('div')(({theme}) => ({
  margin: ' 0px 48px 0px 48px'
}))
